module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-BoldItalic.69debb55.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-BoldItalic.woff
// module id = 528
// module chunks = 0